import { takeEvery, put, call, select, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';
import { updateDiscipleByMap } from 'src/components/therapyPlanning_2.0/commonComponent/updateSingleCellData';

const {
  GET_DATA_THERAPY_PLANNING_REQUEST_2_0,
  GET_DATA_THERAPY_PLANNING_SUCCESS_2_0,
  GET_DATA_THERAPY_PLANNING_FAILURE_2_0,
  GET_DATA_THERAPY_PLANNING_LOADING_2_0,
  GET_DATA_THERAPY_PLANNING_RESET_2_0,
} = therapyPlanningAction;

function* getTherapyPlanningData_2_0(payload: any): SagaReturnType<any> {
  try {
    if (payload?.payload?.source === 'GET_WEEKLY') {
      yield put({ type: GET_DATA_THERAPY_PLANNING_LOADING_2_0 });
    }
    const response = yield call(
      therapyPlanningService.getTherapyPlanningOfPatient_2_0,
      payload?.payload
    );
    if (response?.status === 200) {
      // Guard: discard stale responses if patient changed since request was made
      const currentPatientUuid: string = yield select(
        (state: any) => state?.selectPatientReducer?.patientInfo?.uuid
      );
      if (payload?.payload?.patientId && payload?.payload?.patientId !== currentPatientUuid) {
        return;
      }
      yield put({
        type: GET_DATA_THERAPY_PLANNING_SUCCESS_2_0,
        payload: {
          response: response.data,
          requestPayload: payload?.payload?.params,
          source: payload?.payload?.source,
          disciplineToUpdate: updateDiscipleByMap(payload?.payload?.therapyType),
          groupType: payload?.payload?.groupType,
        },
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_DATA_THERAPY_PLANNING_FAILURE_2_0, payload: error });
  }
}

function* getTherapyPlanningDataSaga_2_0() {
  yield takeEvery(GET_DATA_THERAPY_PLANNING_REQUEST_2_0, getTherapyPlanningData_2_0);
}

export default getTherapyPlanningDataSaga_2_0;
